import {faMapPin} from '@fortawesome/free-solid-svg-icons';

export default [
    {
        to: "/admin/exhibitors",
        icon: faMapPin,
        title: "Exhibitors",
    },
];